import { resources } from './src-localization-index.js';
import { DEFAULT_LOCALE } from './src-constants-locale.js';

const mergeNestedObjects = (target, source) => {
  const result = { ...target };
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      const sourceValue = source[key];
      result[key] = typeof sourceValue === "object" && sourceValue !== null ? mergeNestedObjects(result[key] ?? {}, sourceValue) : sourceValue;
    }
  }
  return result;
};
const getLocalizationsFor = (locale) => {
  const resourcesObj = resources[locale.toLowerCase()];
  if (!resourcesObj) {
    console.warn(`Localization for ${locale} not found, falling back to default locale ${DEFAULT_LOCALE}.`);
    return resources[DEFAULT_LOCALE.toLowerCase()];
  }
  return mergeNestedObjects(resources[DEFAULT_LOCALE.toLowerCase()], resourcesObj);
};

export { getLocalizationsFor };
//# sourceMappingURL=src-localization-getLocalizations.js.map
